import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import "./styles/styles.scss";

import Navigation from "./components/nagivation";
import Homepage from "./pages/home";
import DetailPage from "./pages/detail";
import NotFound from "./pages/notFound";

function App() {
  const [theme, setTheme] = useState("light");

  const handleThemeSetter = ({ currentTarget: input }) => {
    if (input.value === "light") setTheme("dark");
    else setTheme("light");
  };

  return (
    <div className={theme === "light" ? "theme-light" : "theme-dark"}>
      <Navigation onClick={handleThemeSetter} theme={theme} />

      <Routes>
        <Route index path="/" element={<Homepage />} />
        <Route path="/detail/:name" element={<DetailPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
